module.exports = __webpack_public_path__ + "img/bookingflow.9f5ca991.png";